import React from "react";
import { Link, useLocation } from "react-router";
import MenuButton from "./MenuButton";

const Navbar = () => {
	const location = useLocation();

	const links = [
		// { label: "Home", href: "/" },
		{ label: "CombinePDF", href: "/pdf-merge" },
		{ label: "OrganizePDF", href: "/pdf-organize" },
		{ label: "ConvertPDF", href: "/pdf-convert" },
	];

	return (
		<nav className="p-3">
			<div
				className={`flex flex-col sm:flex-row sm:items-center justify-between`}
			>
				<div className="flex items-center gap-1 text-slate-900">
					<img src="./assets/appLogo3.png" alt="" className="w-[40px]" />
					<a href="/" className="text-2xl font-bold text-red-500">
						PDF Management Tools
					</a>
				</div>

				<div className="flex gap-3">
					{links.map((l) => (
						<Link key={l.href} to={l.href}>
							<MenuButton
								title={l.label}
								txColor={l.href === location.pathname ? true : false}
							/>
						</Link>
					))}
				</div>
			</div>

			<hr className="border-[1px] border-gray-700 mt-3" />
		</nav>
	);
};

export default Navbar;
